module.exports = __webpack_public_path__ + "media/src/images/partners/stifterverband-a2c055bd977e3c30adb5be1c24f22f0d.jpg";